/* ===================================================================
  JS information
  file name  :  script_common.js
  style info :  script_common Javascript
=================================================================== */

var $224 = $.noConflict(true);

(function($){
  $(window).on("load reload resize scroll", function(){
    const trgScTop = $(window).scrollTop();
    const trgWinHei = $(window).outerHeight();
    
    $(".lp_wrap .trigger").each(function(){
      const $el = $(this);
      const elTop = $el.offset().top;
      
      if($el.hasClass("per20")){
        if(elTop <= trgScTop + trgWinHei - (trgWinHei * 0.2)){
          $el.addClass("move");
        }
        else {
          $el.removeClass("move");
        }
      }
      else if($el.hasClass("per100")){
        if(elTop <= trgScTop + trgWinHei - (trgWinHei * 1)){
          $el.addClass("move");
        }
        else{
          $el.removeClass("move");
        }
      }
      else {
        if(elTop <= trgScTop + trgWinHei - (trgWinHei * 0.4)){
          $el.addClass("move");
        }
        else{
          $el.removeClass("move");
        }
      }
    });
  });
})($224);

